<div class="rule-detail-dialog">
    <div *ngIf="loading" class="loading-indicator">
        <span class="k-i-loading"></span> Loading...
    </div>
    <div *ngIf="error" class="error-message">
        {{ error }}
    </div>
    <div *ngIf="rules.length > 0 && !loading">
        <div *ngFor="let rule of rules; let i = index" class="rule-section" [class.multi-rule]="rules.length > 1">
            <h3 *ngIf="rules.length > 1" class="rule-name-header">{{ rule.business_rule_name }}</h3>
            <div class="rule-meta">
                <div class="meta-row">
                    <strong>Start Date:</strong> <span>{{ rule.start_date }}</span>
                </div>
                <div class="meta-row">
                    <strong>Expiry Date:</strong> <span>{{ rule.expiry_date }}</span>
                </div>
                <div class="meta-row" *ngIf="rule.journey_types?.length">
                    <strong>Journey Types:</strong> <span>{{ rule.journey_types.join(', ') }}</span>
                </div>
                <div class="meta-row" *ngIf="rule.days_of_week?.length">
                    <strong>Days of Week:</strong> <span>{{ rule.days_of_week.join(', ') }}</span>
                </div>
                <div class="meta-row" *ngIf="rule.exclusion_dates?.length">
                    <strong>Exclusion Dates:</strong> <span>{{ rule.exclusion_dates.join(', ') }}</span>
                </div>
            </div>

            <div class="rule-grid-section" *ngIf="rule.bucket_rules?.length">
                <h4>Bucket Rules</h4>
                <kendo-grid [data]="rule.bucket_rules" [height]="200" [scrollable]="'scrollable'"
                            [sortable]="true" [sort]="bucketSorts[i] || []"
                            (sortChange)="onBucketSortChange(rule, i, $event)">
                    <kendo-grid-column field="class" title="Class" [width]="80"></kendo-grid-column>
                    <kendo-grid-column field="rule" title="Rule" [width]="70"></kendo-grid-column>
                    <kendo-grid-column field="daysPrior" title="Days Prior" [width]="90"></kendo-grid-column>
                    <kendo-grid-column field="bucketCode" title="Bucket" [width]="70"></kendo-grid-column>
                    <kendo-grid-column field="minAlloc" title="Min Alloc" [width]="85"></kendo-grid-column>
                    <kendo-grid-column field="maxAlloc" title="Max Alloc" [width]="85"></kendo-grid-column>
                </kendo-grid>
            </div>

            <div class="rule-grid-section" *ngIf="rule.journey_rules?.length">
                <h4>Journey Rules</h4>
                <kendo-grid [data]="rule.journey_rules" [height]="200" [scrollable]="'scrollable'"
                            [sortable]="true" [sort]="journeySorts[i] || []"
                            (sortChange)="onJourneySortChange(rule, i, $event)">
                    <kendo-grid-column field="origin" title="Origin" [width]="100"></kendo-grid-column>
                    <kendo-grid-column field="destination" title="Destination" [width]="100"></kendo-grid-column>
                    <kendo-grid-column field="rsid" title="RSIDs" [width]="200">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span *ngIf="!hasOverflowRsids(dataItem.rsid)">{{ getRsidDisplay(dataItem.rsid) }}</span>
                            <span *ngIf="hasOverflowRsids(dataItem.rsid)"
                                  class="rsid-overflow"
                                  [title]="getRsidTooltip(dataItem.rsid)">
                                {{ getRsidDisplay(dataItem.rsid) }}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="volumeTrigger" title="Volume Trigger" [width]="150"
                                       [hidden]="!volumeTriggerVisible()">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{ volumeTriggerLabel(dataItem.volumeTrigger) }}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="volumeFactor" title="Volume Factor" [width]="110"
                                       [hidden]="!volumeTriggerVisible()">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{ volumeFactorDisplay(dataItem) }}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="triggerLegOrigin" title="Trigger Leg Origin" [width]="130"
                                       [hidden]="!volumeTriggerVisible()">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{ triggerLegOriginLabel(dataItem) }}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="triggerLegDestination" title="Trigger Leg Destination" [width]="150"
                                       [hidden]="!volumeTriggerVisible()">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{ triggerLegDestinationLabel(dataItem) }}
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>

    <div *ngIf="unappliedLoading" class="loading-indicator">
        <span class="k-i-loading"></span> Checking rule priorities...
    </div>
    <div *ngIf="unappliedError" class="error-message">
        {{ unappliedError }}
    </div>
    <div *ngIf="nullifiedRuleNames" class="unapplied-section">
        <h4>Applied But No Effect</h4>
        <p class="unapplied-note">
            {{ nullifiedRuleNames }} &mdash; this Max Alloc rule won on priority but a
            bucket-order conflict removed its cap, so it is not changing allocations.
        </p>
    </div>
    <div *ngIf="unappliedRules.length > 0" class="unapplied-section">
        <h4>Not Applied &mdash; Beaten On Priority</h4>
        <p class="unapplied-note">
            These rules apply to this journey but a higher-priority rule took precedence.
            Priority changes take effect on the next overnight run.
        </p>
        <kendo-grid [data]="unappliedRules" [scrollable]="'none'">
            <kendo-grid-column field="ruleName" title="Rule Name" [width]="170"></kendo-grid-column>
            <kendo-grid-column field="ruleType" title="Type" [width]="90"></kendo-grid-column>
            <kendo-grid-column field="ruleBucket" title="Bucket" [width]="80"></kendo-grid-column>
            <kendo-grid-column field="effectivePriority" title="Priority" [width]="80"></kendo-grid-column>
            <kendo-grid-column title="Beaten By" [width]="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ suppressedByLabel(dataItem) }}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
        <div class="unapplied-actions">
            <button *ngFor="let ruleType of reprioritizeRuleTypes()"
                    type="button"
                    class="k-button k-primary"
                    (click)="onReprioritize(ruleType)">
                Re-prioritize {{ ruleType }} rules
            </button>
        </div>
    </div>
</div>
